<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Реестр релизов</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Количество устройств</li>
        </ol>
    </nav>

    <div class="filter-table__input-wrap search-control mb-3">
        <input
            @keyup.delete="onDeleteSearch()"
            @keyup.enter="onSearch()"
            v-model="search"
            type="text"
            class="search-control__input form-control"
            placeholder="Поиск по номеру аптеки или улице"
        >
        <button @click="onSearch()" class="search-control__input-btn reset-btn">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.5 8.333a5.834 5.834 0 1011.667 0 5.834 5.834 0 00-11.667 0zM17.5 17.5l-5-5"
                    stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    </div>

    <table class="service-table table align-middle">
		<thead>
			<tr>
				<th class="col-header" scope="col" v-for="(elem, index) in thead" :key="index">
					<div style="display: flex; gap: 4px; align-items: center; justify-content: center;"
                        class="th-inner sortable asc">
						<span style="width: 95%;">{{ elem }}</span>
					</div>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="row in tbody" :key="row.id">
                <td>{{ `${row.tbody.pharmacy_number} ${row.tbody.location}` }}</td>
				<td>{{ `${row.tbody.device_type} ${row.tbody.device_item}` }}</td>
			</tr>
		</tbody>
	</table>

    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>
import PaginationElement from '../../../../elements/PaginationElement.vue';
import AssignmentsDeviceStatus from "../../../../models/AutomaticUpdateDevices/AssignmentsDeviceStatus";
import ChangePage from "../../../../helpers/ChangePage";

export default {
    name: 'DeviceStatusComponent',

    components: {
        PaginationElement,
    },

    props: {
        route_index: String,
        route_back: String,
        release_id: [String, Number],
        filter: String
    },

    data: function () {
        return {
            assignments: new AssignmentsDeviceStatus({
                route_list: this.route_index,
            }),
            thead: [
                'Локация',
                'Устройство',
            ],
            search: '',
            tbody: [],
            count: 1,
            per_page: 100,
            page: 1,
        }
    },

    methods: {
        loadTable: async function () {
            let response = await this.assignments.loadTable(
                this.release_id,
                this.filter,
                this.page,
                this.per_page,
                this.search,
            );
            this.tbody = response.tbody;

            this.count = response.pages;
            if (this.page > 1 && this.tbody.length === 0) {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        onSearch: async function () {
            this.page = 1;
            await this.loadTable()
        },
        onDeleteSearch: async function () {
            if (this.search.trim() === '') {
                this.page = 1;
                await this.loadTable()
            }
        },
        pageChange: async function (page) {
            this.page = page;
            await this.loadTable();
        },
    },

    mounted() {
        this.loadTable();
    }
}
</script>

<style scoped lang="scss">
    .table {
        width: 40%;
    }
    .filter-table__input-wrap {
        max-width: unset;
        width: 40%;
    }
</style>
